import { NumYearsExperience } from '~Data';

export const minYearsExperienceChoices: { [key in NumYearsExperience]: string } = {
  [NumYearsExperience.None]: 'None',
  [NumYearsExperience.ZeroToOne]: '0-1 Years',
  [NumYearsExperience.OneToThree]: '1-3 Years',
  [NumYearsExperience.ThreeToFive]: '3-5 Years',
  [NumYearsExperience.FivePlus]: '5+ Years',
};
